// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPaymentDetailsStyles } from "@conklin/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.saveCardCheckboxGridItem = {
    css: css`
        margin-top: 16px;
    `,
};
onePageCheckoutPaymentDetailsStyles.poNumberGridItem = onePageCheckoutPaymentDetailsStyles.paymentMethodGridItem = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.taxExmptionWrapper = {
    css: css`
        margin-top: 24px;
        width: 100%;
        position: relative;
    `,
};

onePageCheckoutPaymentDetailsStyles.form = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.taxExmptionCertificateField = {
    cssOverrides: {
        formField: css`
            margin-top: 16px;
        `,
    },
};

onePageCheckoutPaymentDetailsStyles.creditCardAddress = {
    cityGridItem: {
        width: 6,
    },
    stateGridItem: {
        width: 3,
    },
    postalCodeGridItem: {
        width: 3,
    },
};

onePageCheckoutPaymentDetailsStyles.taxExemptionMessage = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    forwardAs: "p",
    css: css`
        margin-top: 16px;
    `,
};
